import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

export default {
  mixins: [
    helpers.work_with_date,
  ],
  mounted () {
    this.approvedUser();
  },
  methods: {
    approvedUser () {
      const params = {
        checksum: this.$route.query.info,
        timezone: this.getTimeZone(),
      };

      Api.auth
        .confirmEmail(params)
        .then((data) => {
          if (data.data.Status) {
            this.$store.dispatch('AUTH_REQUEST', {
              accessToken: data.data.UserToken,
              refreshToken: data.data.RefreshToken,
            })
              .then(() => {
                this.$router.push('/');
              });
          } else {
            this.$router.push('/auth');
          }
        });
    },
  },
};
